import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from './layouts/AppShell';
import { LoginPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { ClientsPage } from './pages/Clients';
import { IntegratorsPage } from './pages/Integrators';
import { CatalogPage } from './pages/Catalog';
import { BookingsPage } from './pages/Bookings';
import { OrdersPage } from './pages/Orders';
import { InquiriesPage } from './pages/Inquiries';
import { SettingsPage } from './pages/Settings';
import { ProtectedRoute } from './pages/ProtectedRoute';

/**
 * Route table. Phase 4 complete — all functional pages shipped.
 *
 * Вход в приложение — Обращения (канбан, дом менеджера), поэтому '/'
 * редиректит на /inquiries; дашборд переехал на отдельный путь /dashboard.
 *
 *   /                → redirect на /inquiries (главный экран — пайплайн)
 *   /inquiries       InquiriesPage (kanban pipeline — the home of the
 *                    sales manager workflow)
 *   /clients         ClientsPage
 *   /integrators     IntegratorsPage (manufacturer-only)
 *   /bookings        BookingsPage
 *   /catalog         CatalogPage (robot models)
 *   /orders          OrdersPage
 *   /dashboard       DashboardPage
 *   /settings        SettingsPage (interface language)
 */
export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: '/', element: <Navigate to="/inquiries" replace /> },
          { path: '/inquiries', element: <InquiriesPage /> },
          { path: '/clients', element: <ClientsPage /> },
          { path: '/bookings', element: <BookingsPage /> },
          { path: '/catalog', element: <CatalogPage /> },
          { path: '/orders', element: <OrdersPage /> },
          { path: '/dashboard', element: <DashboardPage /> },
          { path: '/settings', element: <SettingsPage /> },
        ],
      },
    ],
  },
  // Manufacturer-only routes
  {
    element: <ProtectedRoute requireRole="MANUFACTURER" />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: '/integrators', element: <IntegratorsPage /> },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/inquiries" replace />,
  },
]);
